export const environment = {
  production: true,
  NODE_ENV: 'production',
  disableAnimation: false,
};
